"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_apollo_1 = require("react-apollo");
var ApiRequestsContext_1 = require("./apiRequests/ApiRequestsContext");
var ErrorCatcher_1 = require("./error/components/ErrorCatcher");
var FeatureFlagsContext_1 = require("./featureFlags/FeatureFlagsContext");
var NavTelemetryEventEmitter_1 = require("./NavTelemetryEventEmitter");
var UIActionsContext_1 = require("./uiActions/UIActionsContext");
var SiteUrlsContext_1 = require("./urls/SiteUrlsContext");
var UserAndSiteSettingsContext_1 = require("./utils/UserAndSiteSettingsContext");
/**
 * Provider for the EmbeddableVizClientLineagePanel since it doesn't need the [[ApiRequests]] object
 */
var VizClientDataCatalogProvider = /** @class */ (function (_super) {
    __extends(VizClientDataCatalogProvider, _super);
    function VizClientDataCatalogProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VizClientDataCatalogProvider.prototype.render = function () {
        return (React.createElement(ErrorCatcher_1.ErrorCatcher, null,
            React.createElement(react_apollo_1.ApolloProvider, { client: this.props.client },
                React.createElement(SiteUrlsContext_1.SiteUrlsContext.Provider, { value: this.props.siteUrls },
                    React.createElement(FeatureFlagsContext_1.FeatureFlagsContext.Provider, { value: this.props.featureFlags }, this.props.children)))));
    };
    return VizClientDataCatalogProvider;
}(React.Component));
exports.VizClientDataCatalogProvider = VizClientDataCatalogProvider;
var FeatureFlagsProvider = /** @class */ (function (_super) {
    __extends(FeatureFlagsProvider, _super);
    function FeatureFlagsProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeatureFlagsProvider.prototype.render = function () {
        return (React.createElement(FeatureFlagsContext_1.FeatureFlagsContext.Provider, { value: this.props.featureFlags }, this.props.children));
    };
    return FeatureFlagsProvider;
}(React.Component));
exports.FeatureFlagsProvider = FeatureFlagsProvider;
/**
 * Wrapper for exported components when they only need the shared URLs context.
 */
var SiteUrlsProvider = /** @class */ (function (_super) {
    __extends(SiteUrlsProvider, _super);
    function SiteUrlsProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SiteUrlsProvider.prototype.render = function () {
        return (React.createElement(SiteUrlsContext_1.SiteUrlsContext.Provider, { value: this.props.siteUrls }, this.props.children));
    };
    return SiteUrlsProvider;
}(React.Component));
exports.SiteUrlsProvider = SiteUrlsProvider;
/**
 * Provider for lineage browser components
 */
var LineageBrowserDataCatalogProvider = /** @class */ (function (_super) {
    __extends(LineageBrowserDataCatalogProvider, _super);
    function LineageBrowserDataCatalogProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LineageBrowserDataCatalogProvider.prototype.render = function () {
        return (React.createElement(ErrorCatcher_1.ErrorCatcher, null,
            React.createElement(React.Fragment, null,
                React.createElement(NavTelemetryEventEmitter_1.NavTelemetryEventEmitter, { uiActions: this.props.uiActions }),
                React.createElement(react_apollo_1.ApolloProvider, { client: this.props.client },
                    React.createElement(SiteUrlsContext_1.SiteUrlsContext.Provider, { value: this.props.siteUrls },
                        React.createElement(FeatureFlagsContext_1.FeatureFlagsContext.Provider, { value: this.props.featureFlags },
                            React.createElement(ApiRequestsContext_1.ApiRequestsContext.Provider, { value: this.props.apiRequests },
                                React.createElement(UIActionsContext_1.UIActionsContext.Provider, { value: this.props.uiActions },
                                    React.createElement(UserAndSiteSettingsContext_1.UserAndSiteSettingsContext.Provider, { value: { areUsersVisible: this.props.areUsersVisible } }, this.props.children)))))))));
    };
    return LineageBrowserDataCatalogProvider;
}(React.Component));
exports.LineageBrowserDataCatalogProvider = LineageBrowserDataCatalogProvider;
/**
 * Provider for the data catalog stuff in VizPortal's search results page.
 *
 * Note (abrandon 2020-03-23) This probably contains more providers than we actually need for search results, but I don't want to risk
 * removing some and accidentally breaking something. If we ever get to a point where it's difficult to pass in the required info,
 * it might be possible to remove the provider in question.
 */
var VizPortalSearchResultsDataCatalogProvider = /** @class */ (function (_super) {
    __extends(VizPortalSearchResultsDataCatalogProvider, _super);
    function VizPortalSearchResultsDataCatalogProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VizPortalSearchResultsDataCatalogProvider.prototype.render = function () {
        return (React.createElement(ErrorCatcher_1.ErrorCatcher, null,
            React.createElement(React.Fragment, null,
                React.createElement(react_apollo_1.ApolloProvider, { client: this.props.client },
                    React.createElement(SiteUrlsContext_1.SiteUrlsContext.Provider, { value: this.props.siteUrls },
                        React.createElement(FeatureFlagsContext_1.FeatureFlagsContext.Provider, { value: this.props.featureFlags },
                            React.createElement(ApiRequestsContext_1.ApiRequestsContext.Provider, { value: this.props.apiRequests },
                                React.createElement(UIActionsContext_1.UIActionsContext.Provider, { value: this.props.uiActions },
                                    React.createElement(UserAndSiteSettingsContext_1.UserAndSiteSettingsContext.Provider, { value: { areUsersVisible: this.props.areUsersVisible } }, this.props.children)))))))));
    };
    return VizPortalSearchResultsDataCatalogProvider;
}(React.Component));
exports.VizPortalSearchResultsDataCatalogProvider = VizPortalSearchResultsDataCatalogProvider;
/**
 * Provider for DQW components in VizPortal.
 */
var VizPortalDQWDataCatalogProvider = /** @class */ (function (_super) {
    __extends(VizPortalDQWDataCatalogProvider, _super);
    function VizPortalDQWDataCatalogProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VizPortalDQWDataCatalogProvider.prototype.render = function () {
        return (React.createElement(ErrorCatcher_1.ErrorCatcher, null,
            React.createElement(React.Fragment, null,
                React.createElement(react_apollo_1.ApolloProvider, { client: this.props.client },
                    React.createElement(SiteUrlsContext_1.SiteUrlsContext.Provider, { value: this.props.siteUrls },
                        React.createElement(FeatureFlagsContext_1.FeatureFlagsContext.Provider, { value: this.props.featureFlags },
                            React.createElement(ApiRequestsContext_1.ApiRequestsContext.Provider, { value: this.props.apiRequests },
                                React.createElement(UIActionsContext_1.UIActionsContext.Provider, { value: this.props.uiActions }, this.props.children))))))));
    };
    return VizPortalDQWDataCatalogProvider;
}(React.Component));
exports.VizPortalDQWDataCatalogProvider = VizPortalDQWDataCatalogProvider;
//# sourceMappingURL=DataCatalogProvider.js.map